module.exports = __webpack_public_path__ + "img/loading.b5b0ce01.gif";